import controller from './manage-subscription.controller';
import './manage-subscription.less';

export default {
  bindings: {
    packet: '<',
    invoice: '<',
    payment: '@',
    cardx: '<',
    subscription: '<'
  },
  controller,
  template: require('./manage-subscription.html')
};



// WEBPACK FOOTER //
// src/app/manage-subscription/manage-subscription.component.ts